const codeChecker = (value, t) => {
  const { codes, name } = value;
  let code = '';

  if (name !== t('flightstatus.search.nocity') && codes) {
    code = codes;
  } else if (name !== t('flightstatus.search.nocity')) {
    const array = name.split(' ');
    code = array[array.length - 1];
  } else {
    code = '';
  }

  return code;
};

export default codeChecker;
